<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Envios de Holerite</h4>
          <form @submit.prevent="handleUpload" class="text-left">
            <div class="col-sm-4">
              <!-- Campo de seleção de mês -->
              <div class="form-group">
                <label for="mesReferencia">Mês Referente</label>
                <select v-model="mesSelecionado" class="form-control">
                  <option
                    v-for="mes in meses"
                    :key="mes.value"
                    :value="mes.value"
                  >
                    {{ mes.label }}
                  </option>
                </select>
              </div>

              <!-- Seleção de Tipo -->
              <div class="form-group">
                <label for="tipoHolerite">Tipo de Holerite</label>
                <select v-model="tipoSelecionado" class="form-control">
                  <option value="Mensal">Mensal</option>
                  <option value="Adiantamento">Adiantamento</option>
                  <option value="Bônus">Bônus</option>
                  <option value="13º Salário">13º Salário</option>
                  <option value="Férias">Férias</option>
                  <option value="Rescisão">Rescisão</option>
                  <option value="Complementar">Complementar</option>
                </select>
              </div>

              <!-- Input de arquivo -->
              <div class="form-group">
                <label for="fileUpload">Selecionar Arquivo</label>
                <div class="custom-file">
                  <input
                    id="fileUpload"
                    type="file"
                    accept="application/pdf"
                    @change="onFileChange"
                    :disabled="isLoading"
                    class="custom-file-input"
                  />
                  <label class="custom-file-label" for="fileUpload">
                    {{ selectedFileName || "Nenhum arquivo selecionado" }}
                  </label>
                </div>
              </div>

              <!-- Alerta fixo -->
              <div class="alert alert-danger mt-2" role="alert">
                <strong>ATENÇÃO:</strong>
                <ul class="mb-0">
                  <li>
                    Só é possível enviar um arquivo pdf de holerites em lote por
                    mês e tipo de Holerite;
                  </li>
                  <li>
                    O arquivo PDF deve conter somente um holerite por página (1
                    funcionário em cada página);
                  </li>
                  <li>
                    Deve constar o CPF do funcionário no layout do holerite.
                    Caso não tenha o CPF, utilize a opção individual de envio
                    por funcionário.
                  </li>
                </ul>
              </div>

              <!-- Botão de envio -->
              <base-button
                type="success"
                :disabled="
                  !selectedFile ||
                    isLoading ||
                    !mesSelecionado ||
                    !tipoSelecionado
                "
                @click="handleUpload()"
                class="btn btn-primary mt-2"
              >
                Enviar
              </base-button>
            </div>
          </form>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      ></loading>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card } from "@/components/index";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      selectedFile: null,
      selectedFileName: "", // Para exibir o nome do arquivo
      mesSelecionado: "",
      tipoSelecionado: "Mensal",
      meses: this.gerarMeses(),
    };
  },
  methods: {
    gerarMeses() {
      const meses = [];
      const hoje = new Date();
      for (let i = 0; i < 12; i++) {
        const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
        const mesFormatado = `${String(data.getMonth() + 1).padStart(
          2,
          "0",
        )}/${data.getFullYear()}`;
        const dataCompleta = `${data.getFullYear()}-${String(
          data.getMonth() + 1,
        ).padStart(2, "0")}-01`;
        meses.push({ label: mesFormatado, value: dataCompleta });
      }
      return meses;
    },
    onFileChange(event) {
      const file = event.target.files[0];

      if (file && file.type === "application/pdf") {
        this.selectedFile = file;
        this.selectedFileName = file.name; // Atualiza o nome do arquivo exibido
      } else {
        this.selectedFile = null;
        this.selectedFileName = "";
        swal("Erro", "O arquivo selecionado não é um PDF válido.", "error");
        event.target.value = "";
      }
    },
    async handleUpload() {
      if (!this.selectedFile || !this.mesSelecionado) {
        swal("Erro", "Selecione um arquivo e um mês para enviar.", "error");
        return;
      }

      this.isLoading = true;

      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("setDB", this.$cookies.get("db"));
      formData.append("mesReferencia", this.mesSelecionado);
      formData.append("tipo_holerite", this.tipoSelecionado);

      try {
        const response = await this.axios.post("/api/envioHolerite", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        });

        this.isLoading = false;

        if (response.data && response.data.message) {
          swal("Sucesso", `${response.data.message}`, "success");
        } else {
          swal("Aviso", "Nenhum CPF encontrado no PDF.", "info");
        }

        this.selectedFile = null;
        this.selectedFileName = "";
        this.mesSelecionado = "";
        this.tipoSelecionado = "Mensal";
        setTimeout(() => {
          location.reload();
        }, 2000);
      } catch (error) {
        console.error("Erro ao enviar arquivo:", error);
        this.isLoading = false;
        swal("Erro", "Falha ao enviar o arquivo.", "error");
      }
    },
  },
};
</script>

<style>
.mt-0 {
  margin-top: 0;
}
.alert-danger {
  font-size: 0.875rem;
  background-color: #f8d7da;
  color: #721c24;
  border-color: #f5c6cb;
}
.custom-file-input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
.custom-file-label {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
</style>
